import { StatusV2, formatCurrency, getFriendlyDate } from "@vellum/ui";
import { usePayroll } from "@/lib/payroll/PayrollProvider";

export function ApprovalsPage() {
  const { payrollWindow, users, approveUser } = usePayroll();

  return (
    <div>
      <p className="mb-4 max-w-2xl text-sm text-gray-600">
        Users with completed jobs in the current window (
        {getFriendlyDate(payrollWindow.start)} –{" "}
        {getFriendlyDate(payrollWindow.end)}
        ). Approving a user unlocks their downloadable payroll statement.
      </p>
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
        <table className="w-full border-collapse text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 bg-gray-50 text-xs uppercase text-gray-500">
              <th className="px-4 py-3 font-semibold">User</th>
              <th className="px-4 py-3 font-semibold">Role</th>
              <th className="px-4 py-3 text-right font-semibold">Jobs</th>
              <th className="px-4 py-3 text-right font-semibold">Total pay</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="px-4 py-3 text-right font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr
                key={user.userId}
                className="border-b border-gray-100 last:border-b-0"
              >
                <td className="px-4 py-3 font-medium text-green-700">
                  {user.name}
                  {user.isCurrentUser ? (
                    <span className="ml-1.5 text-xs font-normal text-gray-500">
                      (you)
                    </span>
                  ) : null}
                </td>
                <td className="px-4 py-3 text-gray-600">{user.role}</td>
                <td className="px-4 py-3 text-right text-gray-700">
                  {user.jobsCompleted}
                </td>
                <td className="px-4 py-3 text-right text-gray-700">
                  {formatCurrency(user.totalPay)}
                </td>
                <td className="px-4 py-3">
                  <StatusV2 status={user.status} />
                </td>
                <td className="px-4 py-3 text-right">
                  {user.status === "pending" ? (
                    <button
                      type="button"
                      onClick={() => approveUser(user.userId)}
                      className="rounded-md bg-green-700 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-green-700/90"
                    >
                      Approve
                    </button>
                  ) : (
                    <span className="text-xs text-gray-400">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
